import Vue from 'vue'

import Icon from 'vue-awesome/components/Icon.vue'
import VueFlatpickr from 'vue-flatpickr-component'
import Loading from '../components/Loading.vue'
import Pagination from '../components/Pagination.vue'

export default class ComponentProvider {
  static register () {
    Vue.component('icon', Icon)
    Vue.component('flatpickr', VueFlatpickr)
    Vue.component('loading', Loading)
    Vue.component('pagination', Pagination);
  }
}



// WEBPACK FOOTER //
// ./src/ui/ComponentProvider.js